class FeaturedCollectionSlider {
  constructor() {
    this.init();
  }

  init() {
    // Находим все слайдеры featured-collection
    document.querySelectorAll('slider-component').forEach(sliderComponent => {
      const pagination = sliderComponent.querySelector('.slider-pagination--featured-collection');
      if (!pagination) return;

      const slider = sliderComponent.querySelector('[id^="Slider-"]');
      if (!slider) return;

      // Переопределяем обработчики кнопок для переключения по 4 слайда
      this.setupNavigationButtons(sliderComponent, slider);

      // Создаем точки пагинации на основе количества страниц (по 4 слайда)
      this.createPaginationDots(sliderComponent, pagination, slider);

      // Обновляем при изменении размера окна
      const resizeObserver = new ResizeObserver(() => {
        this.setupNavigationButtons(sliderComponent, slider);
        this.createPaginationDots(sliderComponent, pagination, slider);
      });
      resizeObserver.observe(slider);
    });
  }

  setupNavigationButtons(sliderComponent, slider) {
    const prevButton = sliderComponent.querySelector('button[name="previous"]');
    const nextButton = sliderComponent.querySelector('button[name="next"]');
    
    // Проверяем, не установлены ли уже обработчики
    if (!prevButton || !nextButton || prevButton.hasAttribute('data-featured-collection-handler')) return;

    // Получаем слайды
    const slides = slider.querySelectorAll('[id^="Slide-"]');
    const sliderItems = Array.from(slides).filter((element) => element.clientWidth > 0);
    
    if (sliderItems.length < 2) return;
    
    const sliderItemOffset = sliderItems[1].offsetLeft - sliderItems[0].offsetLeft;
    const slidesPerPage = 4; // Переключаем по 4 слайда

    // Создаем обработчики
    const prevHandler = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const currentScroll = slider.scrollLeft;
      const newPosition = Math.max(0, currentScroll - (slidesPerPage * sliderItemOffset));
      slider.scrollTo({
        left: newPosition,
        behavior: 'smooth'
      });
    };

    const nextHandler = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const currentScroll = slider.scrollLeft;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const newPosition = Math.min(maxScroll, currentScroll + (slidesPerPage * sliderItemOffset));
      slider.scrollTo({
        left: newPosition,
        behavior: 'smooth'
      });
    };

    // Добавляем обработчики с высоким приоритетом (capture phase)
    // чтобы перехватить событие до стандартного обработчика SliderComponent
    prevButton.addEventListener('click', prevHandler, true);
    nextButton.addEventListener('click', nextHandler, true);
    
    // Сохраняем ссылки на обработчики для возможного удаления
    prevButton._featuredCollectionHandler = prevHandler;
    nextButton._featuredCollectionHandler = nextHandler;
    prevButton.setAttribute('data-featured-collection-handler', 'true');
    nextButton.setAttribute('data-featured-collection-handler', 'true');
  }

  createPaginationDots(sliderComponent, pagination, slider) {
    // Получаем количество страниц из слайдера
    const slides = slider.querySelectorAll('[id^="Slide-"]');
    if (slides.length === 0) return;

    // Вычисляем количество страниц
    const sliderItems = Array.from(slides).filter((element) => element.clientWidth > 0);
    if (sliderItems.length < 2) {
      pagination.style.display = 'none';
      return;
    }

    const sliderItemOffset = sliderItems[1].offsetLeft - sliderItems[0].offsetLeft;
    const slidesPerGroup = 4; // Группируем по 4 слайда
    const totalGroups = Math.ceil(sliderItems.length / slidesPerGroup);

    // Очищаем существующие точки
    pagination.innerHTML = '';

    // Создаем новые точки (по одной на каждую группу из 4 слайдов)
    for (let i = 0; i < totalGroups; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `slider-pagination__dot${i === 0 ? ' slider-pagination__dot--active' : ''}`;
      dot.setAttribute('aria-label', `Go to group ${i + 1} of ${totalGroups}`);
      dot.setAttribute('data-group-index', i);
      dot.addEventListener('click', () => {
        this.goToGroup(slider, i, sliderItems, sliderItemOffset, slidesPerGroup);
      });
      pagination.appendChild(dot);
    }

    // Обновляем активную точку при изменении слайда
    const updateActiveDot = () => {
      const currentScroll = slider.scrollLeft;
      const currentGroup = Math.floor((currentScroll / sliderItemOffset) / slidesPerGroup);
      const dots = pagination.querySelectorAll('.slider-pagination__dot');
      this.updatePagination(dots, Math.min(currentGroup, totalGroups - 1));
    };

    // Слушаем события прокрутки
    slider.addEventListener('scroll', updateActiveDot, { passive: true });

    // Устанавливаем начальную активную точку
    this.updatePagination(pagination.querySelectorAll('.slider-pagination__dot'), 0);
  }

  goToGroup(slider, groupIndex, sliderItems, sliderItemOffset, slidesPerGroup) {
    if (!slider || !sliderItems[groupIndex * slidesPerGroup]) return;

    const slidePosition = (groupIndex * slidesPerGroup) * sliderItemOffset;
    
    slider.scrollTo({
      left: slidePosition,
      behavior: 'smooth'
    });
  }

  goToSlide(sliderComponent, slideIndex) {
    const slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = slider.querySelectorAll('[id^="Slide-"]');
    if (!slides[slideIndex]) return;

    // Вычисляем позицию для прокрутки
    const slidePosition = slides[slideIndex].offsetLeft;
    
    slider.scrollTo({
      left: slidePosition,
      behavior: 'smooth'
    });
  }

  updatePagination(dots, activeIndex) {
    if (!dots || dots.length === 0) return;
    
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('slider-pagination__dot--active');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('slider-pagination__dot--active');
        dot.removeAttribute('aria-current');
      }
    });
  }
}

// Инициализация после загрузки DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FeaturedCollectionSlider();
  });
} else {
  new FeaturedCollectionSlider();
}

// Переинициализация для динамически добавленного контента
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      new FeaturedCollectionSlider();
    }, 100);
  });
}

